var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-box"},[_c('img',{staticClass:"preview-img",attrs:{"src":_vm.imgUrl,"alt":"视频预览图"}}),_c('div',{staticClass:"playButton"})])}
var staticRenderFns = []

export { render, staticRenderFns }